module.exports = __webpack_public_path__ + "static/media/hospital-bed.1f8d2d06.mp3";